










































































import { Component, Prop } from 'vue-property-decorator';
import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { InputPages } from '../../components/organisms/InputPages';
import CheckBox from '../../components/inputs/CheckBox.vue';

@Component({
  components: {},
})
export default class TeacherMotivationPage extends InputPages {
  @Prop()
  value!: Teacher;

  get model() {
    return this.value;
  }

  set model(value) {
    this.value = value;
  }
}
